export default __webpack_public_path__ + "static/media/1.505df4ad.png";